import TekHome from '@/views/TekHome.vue';
import Security from '@/views/Security.vue';
import ScopeSubCreate from '@/views/ScopeSubCreate.vue';
import ScopeSubView from '@/views/ScopeSubView.vue';
import DriveSubEdit from '@/views/DriveSubEdit.vue';
import DriveSubView from '@/views/DriveSubView.vue';
import Address from '@/views/Address.vue';
import LegacyTekScope from '@/views/LegacyTekScope.vue';
import RedeemCode from '@/views/RedeemCode.vue';
import Promotions from '@/views/promotions/Promotions.vue';
import Survey from '@/views/Survey.vue';
import TektronixReceipt from '@/views/receipts/Tektronix.vue';

export default [
	{
		path: '/',
		name: 'home',
		component: TekHome,
		meta: {
			requiresAuth: true,
			title: 'Home'
		}
	},
	{
		path: '/security',
		name: 'security',
		component: Security,
		meta: {
			requiresAuth: true,
			title: 'Security'
		}
	},
	{
		path: '/subscriptions/scope',
		name: "subscriptions/scope",
		component: ScopeSubCreate,
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'TekScope Subscription'
		}
	},
	{
		path: '/subscriptions/scope/:subId?',
		name: "subscriptions/scope-view",
		component: ScopeSubView,
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'TekScope Subscription'
		}
	},
	{
		path: '/subscriptions/drive',
		name: "subscriptions/drive",
		component: DriveSubEdit,
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'TekDrive Subscription'
		}
	},
	{
		path: '/subscriptions/drive/:subId?',
		name: "subscriptions/drive-view",
		component: DriveSubView,
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'TekDrive Subscription'
		}
	},
	{
		path: '/promotions/:code?',
		name: 'promotions',
		component: Promotions,
		props: (route) => ({ promoUrl: route.query.from, code: route.params.code }),
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'TekCloud Promotions'
		}
	},
	{
		path: '/codes/redeem',
		name: "code",
		component: RedeemCode,
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'Redeem Code'
		}
	},
	{
		path: '/address',
		name: "address",
		component: Address,
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'Address'
		}
	},
	{
		path: '/legacy-tekscope',
		name: "legacy-tekscope",
		component: LegacyTekScope,
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'Legacy Plan'
		}
	},
	{
		path: '/survey/:surveyId',
		name: 'survey',
		component: Survey,
		meta: {
			noScroll: true,
			hideMainHeader: true,
			title: 'Survey'
		}
	},
	{
		path: '/receipt/:id',
		name: 'receipt',
		component: TektronixReceipt,
		meta: {
			requiresAuth: true,
			title: 'Receipt'
		}
	}
];



// WEBPACK FOOTER //
// ./src/router/tekcloud.js